@if (project.visible) {
  <mat-card
    class="library-project"
    (click)="showDetails()"
    (keyup.enter)="showDetails()"
    [@flash]="{ value: '*', params: { duration: animateDuration, delay: animateDelay } }"
    role="button"
    tabindex="0"
    i18n-aria-label
    aria-label="Show project details"
  >
    <div class="library-project__cover" [style.background-image]="project.thumbStyle">
      @if (myUnit) {
        <mat-checkbox
          [(ngModel)]="checked"
          class="library-project__checkbox app-bg-bg"
          color="primary"
          matTooltip="Select unit"
          matTooltipPosition="above"
          i18n-matTooltip
          (click)="selectProject($event)"
        />
      }
    </div>
    <app-library-project-disciplines [project]="project" />
    <div
      class="library-project__details can-highlight"
      [ngClass]="{ 'highlighted-bg': project.isHighlighted }"
    >
      <p class="library-project__title">
        {{ project.metadata.title }}&nbsp;
        <span class="mat-caption secondary-text" i18n>(ID: {{ project.id }})</span>&nbsp;
        @if (project.wiseVersion === 4) {
          <mat-icon
            color="warn"
            i18n-matTooltip
            matTooltip="Legacy Unit"
            [matTooltipPosition]="'above'"
            >warning</mat-icon
          >
        }
      </p>
      @if (project.shared) {
        <p class="info mat-caption" i18n>Shared by {{ project.owner.displayName }}</p>
      }
      <div class="tags">
        <unit-tags class="mat-small" [tags]="project.tags" />
      </div>
    </div>
  </mat-card>
}
